// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header {
  display: flex;
  justify-content: center; /* Center the navigation */
  align-items: center;
  width: 100%; /* Takes full width */
  padding: 0.5rem 2rem; /* Reduced top/bottom padding */
  background-color: rgba(0, 0, 0, 0.0);
  position: fixed; /* Make header fixed at top */
  top: -10px;
  left: 0;
  right: 0;
  z-index: 150; /* Higher than logo to ensure proper stacking */
  margin: 0; /* Ensure no margin */
}

.header.header-compact {
  background-color: transparent;
  padding-right: 0;
  position: absolute;
  top: 0;
  z-index: 100;
}

.logo-container {
  position: fixed; /* Make logo fixed */
  top: 16px; /* Top-left corner positioning */
  left: 16px; /* Top-left corner positioning */
  z-index: 200; /* Ensure logo is above other content */
  transition: left 0.3s ease, width 0.3s ease, top 0.3s ease;
}

/* In viewer mode, use viewer-bar positioning */
body.viewer-mode .logo-container {
  top: clamp(16px, 3vh, 32px);
  left: clamp(16px, calc(var(--viewer-bar-width) * 0.15), calc(var(--viewer-bar-width) * 0.5 - 110px));
}

.logo-link {
  position: relative;
  display: block;
  /* Logo scales proportionally with page margins */
  width: min(calc(var(--page-margin-width) * 0.8), 220px);
  transition: transform 0.3s ease-in-out, width 0.3s ease;
  transform-origin: center;
}

/* In viewer mode, use different scaling */
body.viewer-mode .logo-link {
  width: clamp(140px, calc(10vw + 20px), 220px);
}

.logo-link.logo-hovered {
  transform: scale(1.1) rotate(5deg);
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3));
}

.logo-image {
  width: 100%;
  height: auto;
  display: block; /* Prevents extra space below image */
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease;
}

.logo-image-color {
  position: relative;
  opacity: 1;
}

.logo-image-white {
  opacity: 0;
}

.logo-link.logo-hovered .logo-image-color {
  opacity: 0;
}

.logo-link.logo-hovered .logo-image-white {
  opacity: 1;
}

.navigation {
  display: flex;
  gap: 0;
  align-items: center;
}

/* Header-specific navigation buttons */
.header-nav-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
}

.header-nav-button:hover,


.header-nav-icon-wrapper {
  position: relative;
  display: inline-block;
  height: clamp(80px, 9vh, 180px);
}

.header-nav-icon {
  display: block;
  height: clamp(80px, 9vh, 180px);
  width: auto;
  transition: opacity 0.2s ease;
}

.header-nav-icon-default {
  position: relative;
  opacity: 1;
}

.header-nav-icon-active {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.header-nav-button:hover .header-nav-icon-default {
  opacity: 0;
}

.header-nav-button:hover .header-nav-icon-active {
  opacity: 1;
}


/* Screen reader only text */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Responsive logo adjustments */
/* When margins disappear (1400px), hide logo on non-viewer pages */
@media (max-width: 1400px) {
  body:not(.viewer-mode) .logo-container {
    display: none;
  }
  
  /* Keep logo visible in viewer mode */
  body.viewer-mode .logo-container {
    display: block;
  }
}

@media (max-width: 768px) {
  .header-nav-icon-wrapper {
    height: clamp(60px, 8vh, 140px);
  }
  
  .header-nav-icon {
    height: clamp(60px, 8vh, 140px);
  }
}

@media (max-width: 480px) {
  .header {
    padding: 0.5rem 1rem;
  }
  
  .header-nav-icon-wrapper {
    height: clamp(50px, 7vh, 100px);
  }
  
  .header-nav-icon {
    height: clamp(50px, 7vh, 100px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB,EAAE,0BAA0B;EACnD,mBAAmB;EACnB,WAAW,EAAE,qBAAqB;EAClC,oBAAoB,EAAE,+BAA+B;EACrD,oCAAoC;EACpC,eAAe,EAAE,6BAA6B;EAC9C,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,+CAA+C;EAC7D,SAAS,EAAE,qBAAqB;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,eAAe,EAAE,oBAAoB;EACrC,SAAS,EAAE,gCAAgC;EAC3C,UAAU,EAAE,gCAAgC;EAC5C,YAAY,EAAE,uCAAuC;EACrD,0DAA0D;AAC5D;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,oGAAoG;AACtG;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iDAAiD;EACjD,uDAAuD;EACvD,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,qCAAqC;EACrD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;EAIE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;AAChC,mEAAmE;AACnE;EACE;IACE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["\n.header {\n  display: flex;\n  justify-content: center; /* Center the navigation */\n  align-items: center;\n  width: 100%; /* Takes full width */\n  padding: 0.5rem 2rem; /* Reduced top/bottom padding */\n  background-color: rgba(0, 0, 0, 0.0);\n  position: fixed; /* Make header fixed at top */\n  top: -10px;\n  left: 0;\n  right: 0;\n  z-index: 150; /* Higher than logo to ensure proper stacking */\n  margin: 0; /* Ensure no margin */\n}\n\n.header.header-compact {\n  background-color: transparent;\n  padding-right: 0;\n  position: absolute;\n  top: 0;\n  z-index: 100;\n}\n\n.logo-container {\n  position: fixed; /* Make logo fixed */\n  top: 16px; /* Top-left corner positioning */\n  left: 16px; /* Top-left corner positioning */\n  z-index: 200; /* Ensure logo is above other content */\n  transition: left 0.3s ease, width 0.3s ease, top 0.3s ease;\n}\n\n/* In viewer mode, use viewer-bar positioning */\nbody.viewer-mode .logo-container {\n  top: clamp(16px, 3vh, 32px);\n  left: clamp(16px, calc(var(--viewer-bar-width) * 0.15), calc(var(--viewer-bar-width) * 0.5 - 110px));\n}\n\n.logo-link {\n  position: relative;\n  display: block;\n  /* Logo scales proportionally with page margins */\n  width: min(calc(var(--page-margin-width) * 0.8), 220px);\n  transition: transform 0.3s ease-in-out, width 0.3s ease;\n  transform-origin: center;\n}\n\n/* In viewer mode, use different scaling */\nbody.viewer-mode .logo-link {\n  width: clamp(140px, calc(10vw + 20px), 220px);\n}\n\n.logo-link.logo-hovered {\n  transform: scale(1.1) rotate(5deg);\n  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3));\n}\n\n.logo-image {\n  width: 100%;\n  height: auto;\n  display: block; /* Prevents extra space below image */\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: opacity 0.3s ease;\n}\n\n.logo-image-color {\n  position: relative;\n  opacity: 1;\n}\n\n.logo-image-white {\n  opacity: 0;\n}\n\n.logo-link.logo-hovered .logo-image-color {\n  opacity: 0;\n}\n\n.logo-link.logo-hovered .logo-image-white {\n  opacity: 1;\n}\n\n.navigation {\n  display: flex;\n  gap: 0;\n  align-items: center;\n}\n\n/* Header-specific navigation buttons */\n.header-nav-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.header-nav-button:hover,\n\n\n.header-nav-icon-wrapper {\n  position: relative;\n  display: inline-block;\n  height: clamp(80px, 9vh, 180px);\n}\n\n.header-nav-icon {\n  display: block;\n  height: clamp(80px, 9vh, 180px);\n  width: auto;\n  transition: opacity 0.2s ease;\n}\n\n.header-nav-icon-default {\n  position: relative;\n  opacity: 1;\n}\n\n.header-nav-icon-active {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.header-nav-button:hover .header-nav-icon-default {\n  opacity: 0;\n}\n\n.header-nav-button:hover .header-nav-icon-active {\n  opacity: 1;\n}\n\n\n/* Screen reader only text */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Responsive logo adjustments */\n/* When margins disappear (1400px), hide logo on non-viewer pages */\n@media (max-width: 1400px) {\n  body:not(.viewer-mode) .logo-container {\n    display: none;\n  }\n  \n  /* Keep logo visible in viewer mode */\n  body.viewer-mode .logo-container {\n    display: block;\n  }\n}\n\n@media (max-width: 768px) {\n  .header-nav-icon-wrapper {\n    height: clamp(60px, 8vh, 140px);\n  }\n  \n  .header-nav-icon {\n    height: clamp(60px, 8vh, 140px);\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    padding: 0.5rem 1rem;\n  }\n  \n  .header-nav-icon-wrapper {\n    height: clamp(50px, 7vh, 100px);\n  }\n  \n  .header-nav-icon {\n    height: clamp(50px, 7vh, 100px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
